const semanticClassNames = {
  root: 'dropdown',
  label: 'dropdown__label',
  icon: 'dropdown__icon',
  input: 'dropdown__input',
  list: 'dropdown__list',
} as const;

export default semanticClassNames;
